import Vue from 'vue';
import uploadApkUrls from '../../../../urls/schedulerUrls';

export const storePrefix = "campaign_scheduler_store";

window.dateToStrng = (dateToStr) => {
    if (dateToStr) {
        const offset = dateToStr.getTimezoneOffset();
        let yourDate = new Date(dateToStr.getTime() - (offset * 60 * 1000));
        return yourDate.toISOString().split('T').join(' ');
    }
    return null
}

window.dateToShortStrng = (dateToStr) => {
    if (dateToStr) {
        const offset = dateToStr.getTimezoneOffset();
        let yourDate = new Date(dateToStr.getTime() - (offset * 60 * 1000));
        return yourDate.toISOString().split('T')[0];
    }
    return null
}

const state = {
    sessionStorageKey: "upload_package_bundle",
    isScheduler: false,
    schedulerStartDate: null,
    schedulerEndDate: null,
}

const getters = {
    isScheduler(state) {
        return state.isScheduler;
    },

    schedulerStartDate(state) {
        return state.schedulerStartDate;
    },

    schedulerEndDate(state) {
        return state.schedulerEndDate;
    },
}

const mutations = {
    [`${storePrefix}setIsScheduler`](state, payload) {
        state.isScheduler = payload;
        model.isScheduler = payload;
        model.currentCampaignObj.isScheduler = payload;
    },

    [`${storePrefix}setSchedulerStartDate`](state, payload) {
        state.schedulerStartDate = payload;
        model.schedulerStartDate = payload;
        model.currentCampaignObj.schedulerStartDate = payload;
    },

    [`${ storePrefix }setSchedulerEndDate`](state, payload) {
        state.schedulerEndDate = payload;
        model.schedulerEndDate =  payload;
        model.currentCampaignObj.schedulerEndDate = payload;
    },
}

const actions = {

    saveSchedulerDates(context, { startDate, endDate }) {
        return new Promise((resolve, reject) => {
            context.commit(`${storePrefix}setIsScheduler`, !!(startDate || endDate));
            context.commit(`${storePrefix}setSchedulerStartDate`, startDate);
            context.commit(`${storePrefix}setSchedulerEndDate`, endDate);
            //context.commit(`${storePrefix}setSchedulerStartDate`, window.dateToStrng(startDate));
            //context.commit(`${storePrefix}setSchedulerEndDate`, window.dateToStrng(endDate));
            resolve();
        });

    },

    clearAllSchedulerDates(context) {
        return new Promise((resolve, reject) => {
            context.commit(`${storePrefix}setIsScheduler`, false);
            context.commit(`${storePrefix}setSchedulerStartDate`, null);
            context.commit(`${storePrefix}setSchedulerEndDate`, null);
            model.isScheduler = false;
            model.schedulerStartDate = null;
            model.schedulerEndDate = null;
            model.currentCampaignObj.isScheduler = false;
            model.currentCampaignObj.schedulerStartDate = null;
            model.currentCampaignObj.schedulerEndDate = null;
            resolve();
        });

    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Campaign/Scheduler/store/scheduler.js